<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="forgetUserName"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto" />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h2 class="mb-8">Forget Your UserName</h2>
                </div>

                <div>
                  <div class="vx-row">
                    <vs-input
                      name="email"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      placeholder="Enter email"
                      v-model="email"
                      class="w-3/4 ml-4"
                    />
                    <vs-button class="ml-4 mt-4" @click.stop="getverifyemail">
                      {{ $t("Submit") }}
                    </vs-button>
                  </div>
                  <vs-input
                    name="Email"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    v-model="veremail.email"
                    class="w-full mt-6"
                  />
                  <div class="vx-row">
                    <vs-button class="ml-4 mt-8" @click.stop="getgeneratekey">
                      {{ $t("Confirm Email") }}
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      email: "",
      Email: "",

      message: "",
    };
  },
  computed: {
    ...mapState({
      veremail: (state) => state.dashboard.email,
    }),
  },
  methods: {
    async getverifyemail() {
      try {
        await this.$store.dispatch("dashboard/setverifyemail", this.email);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getgeneratekey() {
      try {
        await this.$store.dispatch("dashboard/setgeneratekey", this.veremail.email);
        this.$router.push("/login");
      }catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
};
</script>

<style lang="scss">
#forgetUserName {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
